module.exports = __webpack_public_path__ + "static/media/billing_region_logo.8e840fe7.svg";